import { Table, Code, Text, Stack } from '@mantine/core';
import { useAppInfo } from 'src/secret-menu/hooks/useAppInfo';
import PageLoader from 'src/UI/loader/PageLoader';

export default function InfoTab() {
  const { info, isLoading, isError } = useAppInfo();

  if (isLoading) {
    return <PageLoader />;
  }

  if (isError || !info) {
    return <Text c="red">Failed to load app info</Text>;
  }

  return (
    <Stack gap="md">
      <Text fw={600} size="lg">
        Application Info
      </Text>
      <Table maw={600}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Property</Table.Th>
            <Table.Th>Value</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td>Release</Table.Td>
            <Table.Td>
              <Code>{info.version}</Code>
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Stack>
  );
}
